var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, HostListener, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { KtsConstructionTaskService } from '../task/construction-task.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
var KtsGeneralGanttComponent = /** @class */ (function (_super) {
    __extends(KtsGeneralGanttComponent, _super);
    function KtsGeneralGanttComponent(router, route, logger, action, message, page, service, constTaskService, colService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.constTaskService = constTaskService;
        _this.colService = colService;
        _this.visibleComp = true;
        _this.hiddenMenu = false;
        _this.ganttElements = {};
        _this.ganttData = [];
        return _this;
    }
    KtsGeneralGanttComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsGeneralGanttComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.gantts.changes.subscribe(function (gantts) {
            gantts.map(function (gantt) {
                var id = gantt.nativeElement.getAttribute('data-store');
                _this.ganttElements[id].element = gantt.nativeElement;
            });
        });
    };
    KtsGeneralGanttComponent.prototype.ngAfterViewChecked = function () {
        var _this = this;
        var visibleComp = $(this.ganttComp.nativeElement).is(':visible');
        if (this.visibleComp !== visibleComp) {
            this.visibleComp = visibleComp;
            if (this.visibleComp) {
                this.ganttData.map(function (x, i) { return _this.setGantt(i); });
            }
        }
        var hiddenMenu = $('#menuPush').hasClass('pushMenuWrapper-toleft');
        if (this.hiddenMenu !== hiddenMenu) {
            this.hiddenMenu = hiddenMenu;
            window.clearTimeout(this.timeoutID2);
            this.timeoutID2 = window.setTimeout(function () {
                _this.ganttData
                    .filter(function (x) { return _this.ganttElements[x.store_id].width !== _this.ganttElements[x.store_id].element.parentElement.offsetWidth; })
                    .map(function (x, i) {
                    _this.ganttElements[x.store_id].width = _this.ganttElements[x.store_id].element.parentElement.offsetWidth;
                    _this.setGantt(i);
                });
            }, 300);
        }
    };
    KtsGeneralGanttComponent.prototype.switchToggle = function (id, index) {
        var el = this.ganttElements[id];
        $(el.element.parentElement).toggle();
        el.toggle = !el.toggle;
        el.width = el.element.parentElement.offsetWidth;
        this.setGantt(index);
    };
    KtsGeneralGanttComponent.prototype.setToggle = function (flg) {
        var _this = this;
        this.ganttData.map(function (x, i) {
            var el = _this.ganttElements[x.store_id];
            if (flg) {
                $(el.element.parentElement).show();
            }
            else {
                $(el.element.parentElement).hide();
            }
            el.toggle = flg;
            el.width = el.element.parentElement.offsetWidth;
            _this.setGantt(i);
        });
    };
    KtsGeneralGanttComponent.prototype.setGantt = function (index) {
        var ganttData = this.ganttData[index];
        var el = this.ganttElements[ganttData.store_id];
        if (!el.toggle || !ganttData || ganttData.class.length === 0) {
            return;
        }
        var id = 1;
        var data = [];
        for (var _i = 0, _a = ganttData.class; _i < _a.length; _i++) {
            var cls = _a[_i];
            var series = [];
            for (var _b = 0, _c = cls.task; _b < _c.length; _b++) {
                var tk = _c[_b];
                for (var _d = 0, _e = tk.date; _d < _e.length; _d++) {
                    var dt = _e[_d];
                    series.push(dt);
                }
            }
            data.push({ id: id++, name: cls.name, series: series });
        }
        var slideWidth = el.width - 260;
        slideWidth = slideWidth < 335 ? 335 : slideWidth;
        $(el.element).empty();
        $(el.element).ganttView({
            data: data,
            slideWidth: slideWidth,
            behavior: {
                clickable: false,
                draggable: false,
                resizable: false
            },
            yearMonthFormat: this.msgSnapshot['au.COMPONENT.KtsGanttComponent.option.yearMonthFormat']
        });
        var blocks = $(el.element).children('.ganttview').children('.ganttview-slide-container').children('.ganttview-blocks').find('.ganttview-block');
        var count = 0;
        for (var _f = 0, data_1 = data; _f < data_1.length; _f++) {
            var d = data_1[_f];
            for (var _g = 0, _h = d.series; _g < _h.length; _g++) {
                var series = _h[_g];
                // 実施日が無くても枠だけ表示する
                if (series.hidden) {
                    $(blocks[count]).hide();
                }
                count++;
            }
        }
        // 中分類、予定・実施の列の間にタスク名の列を追加
        var headers = $(el.element).children('.ganttview').children('.ganttview-vtheader').find('.ganttview-vtheader-item-name');
        for (var i = 0; i < ganttData.class.length; i++) {
            var cls = ganttData.class[i];
            var taskDiv = '';
            for (var j = 0; j < cls.task.length; j++) {
                var tk = cls.task[j];
                var taskHeight = (tk.date.length > 1 ? ' style="height: ' + (31 * tk.date.length + (tk.date.length - 1)) + 'px;"' : '');
                taskDiv += '<div class="ganttview-vtheader-series-name"' + taskHeight + '>' + tk.name + '</div>';
            }
            $(headers[i]).after('<div class="ganttview-vtheader-series">' + taskDiv + '</div>');
        }
        var width = $(el.element).children('.ganttview').children('.ganttview-slide-container').innerWidth();
        $(el.element).children('.ganttview').children('.ganttview-slide-container').innerWidth(width - 135);
    };
    KtsGeneralGanttComponent.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.timeoutID);
        this.timeoutID = window.setTimeout(function () {
            _this.ganttData.map(function (x, i) {
                _this.ganttElements[x.store_id].width = _this.ganttElements[x.store_id].element.parentElement.offsetWidth;
                _this.setGantt(i);
            });
        }, 300);
    };
    KtsGeneralGanttComponent.prototype.onMsg = function (msg) {
        this.DATE_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatDate']);
        this.DATETIME_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.format']);
    };
    KtsGeneralGanttComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsGeneralGanttComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            return;
        }
        data = JSOG.parse(JSON.stringify(data));
        var ganttData = [];
        for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
            var item = _a[_i];
            var id = item.store_m_id;
            var name_1 = item.store_name ? item.store_name : this.msgSnapshot['au.COMPONENT.KtsGeneralGanttComponent.label.noStoreName'];
            var series = [];
            if (typeof this.ganttElements[id] === 'undefined') {
                this.ganttElements[id] = new GanttElement();
                this.ganttElements[id].minDate = null;
            }
            if (!item.task_m_id) {
                ganttData.push({ store_id: id, name: name_1, class: [] });
                continue;
            }
            if (!item.necessity) {
                continue;
            }
            if (item.template_type === "onsite" /* onsite */ || item.template_type === "onsite_notime" /* onsite_notime */ || item.template_type === "construction" /* construction */) {
                if (typeof item.construction_report_id === 'undefined') {
                    series.push(this.getSeriesHidden());
                }
                else {
                    var plan = this.getSeriesDate(id, "plan" /* plan */, item.visiting_scheduled_date, item.leaving_scheduled_date, this.checkPlanDelay(item.leaving_scheduled_date, item.leaving_actual_date));
                    if (plan !== null) {
                        series.push(plan);
                    }
                    var act = this.getSeriesDate(id, "act" /* act */, item.visiting_actual_date, item.leaving_actual_date, this.checkCompleteDelay(item.visiting_scheduled_date, item.leaving_scheduled_date, item.visiting_actual_date, item.leaving_actual_date));
                    if (act !== null) {
                        series.push(act);
                    }
                    else {
                        series.push(this.getSeriesHidden());
                    }
                }
            }
            else {
                var plan = this.getSeriesDate(id, "plan" /* plan */, item.plan_date, null, this.checkPlanDelay(item.plan_date, item.act_date));
                if (plan !== null) {
                    series.push(plan);
                }
                var act = this.getSeriesDate(id, "act" /* act */, item.act_date, null, this.checkCompleteDelay(item.plan_date, null, item.act_date, null));
                if (act !== null) {
                    series.push(act);
                }
                else {
                    series.push(this.getSeriesHidden());
                }
            }
            if (ganttData.length > 0 && ganttData[ganttData.length - 1].store_id === id) {
                var storeData = ganttData[ganttData.length - 1];
                if (storeData.class.length > 0 && storeData.class[storeData.class.length - 1].class_id === item.construction_middle_classification_id
                    && storeData.class[storeData.class.length - 1].step === item.step) {
                    var classData = storeData.class[storeData.class.length - 1];
                    if (classData.task.length > 0 && classData.task[classData.task.length - 1].task_id === item.task_m_id) {
                        Array.prototype.push.apply(classData.task[classData.task.length - 1].date, series);
                    }
                    else {
                        var taskData = { task_id: item.task_m_id, name: item.task_name, date: series };
                        Array.prototype.push.apply(classData.task, [taskData]);
                    }
                }
                else {
                    var taskData = { task_id: item.task_m_id, name: item.task_name, date: series };
                    var classData = {
                        class_id: item.construction_middle_classification_id,
                        name: item.construction_middle_classification_name,
                        step: item.step,
                        task: [taskData]
                    };
                    Array.prototype.push.apply(storeData.class, [classData]);
                }
            }
            else {
                var taskData = { task_id: item.task_m_id, name: item.task_name, date: series };
                var classData = {
                    class_id: item.construction_middle_classification_id,
                    name: item.construction_middle_classification_name,
                    step: item.step,
                    task: [taskData]
                };
                ganttData.push({ store_id: id, name: name_1, class: [classData] });
            }
        }
        var now = moment().format(this.DATE_DELIMITER_SLASH);
        for (var _b = 0, ganttData_1 = ganttData; _b < ganttData_1.length; _b++) {
            var storeData = ganttData_1[_b];
            var id = storeData.store_id;
            if (!this.ganttElements[id].minDate) {
                this.ganttElements[id].minDate = now;
            }
            var minDate = this.ganttElements[id].minDate;
            for (var _c = 0, _d = storeData.class; _c < _d.length; _c++) {
                var classData = _d[_c];
                for (var _e = 0, _f = classData.task; _e < _f.length; _e++) {
                    var taskData = _f[_e];
                    for (var _g = 0, _h = taskData.date; _g < _h.length; _g++) {
                        var dateData = _h[_g];
                        if (dateData.hidden) {
                            dateData.start = minDate;
                            dateData.end = minDate;
                        }
                    }
                }
            }
        }
        this.ganttData = ganttData;
        this.ganttData.map(function (x, i) { return _this.setGantt(i); });
    };
    KtsGeneralGanttComponent.prototype.getSeriesHidden = function () {
        return {
            name: this.msgSnapshot['au.COMPONENT.KtsGanttComponent.label.act'],
            start: null,
            end: null,
            color: "#4fd028" /* act */,
            hidden: true
        };
    };
    KtsGeneralGanttComponent.prototype.getSeriesDate = function (id, type, start, end, delay) {
        var name = this.msgSnapshot['au.COMPONENT.KtsGanttComponent.label.plan'];
        var color = (delay ? "#e62db5" /* planDelay */ : "#005eaa" /* plan */);
        if (type === "act" /* act */) {
            name = this.msgSnapshot['au.COMPONENT.KtsGanttComponent.label.act'];
            color = (delay ? "#e65e2d" /* completeDelay */ : "#4fd028" /* act */);
        }
        var sDate = null;
        if (this.colService.checkVal(start)) {
            sDate = moment(start, this.DATETIME_DELIMITER_SLASH).format(this.DATE_DELIMITER_SLASH);
        }
        var eDate = null;
        if (this.colService.checkVal(end)) {
            eDate = moment(end, this.DATETIME_DELIMITER_SLASH).format(this.DATE_DELIMITER_SLASH);
        }
        if (sDate && eDate) {
            this.checkMinDate(id, sDate);
            return { name: name, start: sDate, end: eDate, color: color, hidden: false };
        }
        else if (sDate && !eDate) {
            this.checkMinDate(id, sDate);
            return { name: name, start: sDate, end: sDate, color: color, hidden: false };
        }
        else if (!sDate && eDate) {
            this.checkMinDate(id, eDate);
            return { name: name, start: eDate, end: eDate, color: color, hidden: false };
        }
        return null;
    };
    // 予定超過
    KtsGeneralGanttComponent.prototype.checkPlanDelay = function (plan, act) {
        if (plan && !act) {
            var planDate = moment(plan, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            var now = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
            if (planDate.isBefore(now)) {
                return true;
            }
        }
        return false;
    };
    // 完了超過
    KtsGeneralGanttComponent.prototype.checkCompleteDelay = function (planStart, planEnd, actStart, actEnd) {
        if (planStart && actStart) {
            var planDate = moment(planStart, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            var actDate = moment(actStart, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            if (planDate.isBefore(actDate)) {
                return true;
            }
        }
        if (planEnd && actEnd) {
            var planDate = moment(planEnd, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            var actDate = moment(actEnd, this.DATETIME_DELIMITER_SLASH).hours(0).minutes(0).seconds(0).milliseconds(0);
            if (planDate.isBefore(actDate)) {
                return true;
            }
        }
        return false;
    };
    KtsGeneralGanttComponent.prototype.checkMinDate = function (id, date) {
        var el = this.ganttElements[id];
        var d1 = moment(el.minDate, this.DATE_DELIMITER_SLASH);
        var d2 = moment(date, this.DATE_DELIMITER_SLASH);
        if (!el.minDate || d1.isAfter(d2)) {
            el.minDate = date;
        }
    };
    KtsGeneralGanttComponent.prototype.onEvent = function (e1, e2, index) {
        if (e2 === 'open') {
            this.setToggle(true);
        }
        else if (e2 === 'close') {
            this.setToggle(false);
        }
        else if (e2 === 'up') {
            this.ganttData.splice(index - 1, 2, this.ganttData[index], this.ganttData[index - 1]);
        }
        else if (e2 === 'down') {
            this.ganttData.splice(index, 2, this.ganttData[index + 1], this.ganttData[index]);
        }
    };
    KtsGeneralGanttComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-general-gantt',
                    template: "<div id=\"{{ componentName }}\" #ganttComp>\n  <div class=\"-txtalnright\">\n    <pre class=\"tag tag-cyan\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.plan'] }}</pre>\n    <pre class=\"tag tag-lime\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.act'] }}</pre>\n    <pre class=\"tag tag-pink\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.planDelay'] }}</pre>\n    <pre class=\"tag tag-orange\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.completeDelay'] }}</pre>\n    <span class=\"-mr-2\"></span>\n    <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'open', '')\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.openAll'] }}</a>\n    <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'close', '')\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.closeAll'] }}</a>\n  </div>\n  <div *ngFor=\"let store of ganttData; let storeIndex = index;\" class=\"row -ml-2\" [class.-mb-2]=\"storeIndex < ganttData.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <ul class=\"stageFlow_arrows\">\n          <li *ngIf=\"storeIndex > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" style=\"top: -15px; left: -35px;\" (click)=\"onEvent($event, 'up', storeIndex)\"></a></li>\n          <li *ngIf=\"storeIndex < ganttData.length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" style=\"bottom: -40px; left: -35px;\" (click)=\"onEvent($event, 'down', storeIndex)\"></a></li>\n        </ul>\n        <p class=\"filter_trigger\">\n          <span [class.open]=\"ganttElements[store.store_id]?.toggle\" (click)=\"switchToggle(store.store_id, storeIndex)\">{{ store.name }}</span>\n        </p>\n        <div class=\"filter_property_toggle ganttChart\" [style.overflow-x]=\"store.class?.length > 0 ? 'auto' : 'none'\">\n          <p *ngIf=\"!store.class || store.class?.length === 0\" class=\"-mt-1\">{{ (msg | async)['au.COMPONENT.KtsGanttComponent.label.noDate'] }}</p>\n          <div [attr.data-store]=\"store.store_id\" style=\"min-width: 250px;\" #gantt></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsGeneralGanttComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: KtsConstructionTaskService },
        { type: ColumnService }
    ]; };
    KtsGeneralGanttComponent.propDecorators = {
        ganttComp: [{ type: ViewChild, args: ['ganttComp',] }],
        gantts: [{ type: ViewChildren, args: ['gantt',] }],
        onResize: [{ type: HostListener, args: ['window:resize',] }]
    };
    return KtsGeneralGanttComponent;
}(ContentBaseComponent));
export { KtsGeneralGanttComponent };
var GanttElement = /** @class */ (function () {
    function GanttElement() {
        this.toggle = false;
        this.width = 0;
    }
    return GanttElement;
}());
var GanttStoreData = /** @class */ (function () {
    function GanttStoreData() {
    }
    return GanttStoreData;
}());
var GanttClassData = /** @class */ (function () {
    function GanttClassData() {
    }
    return GanttClassData;
}());
var GanttTaskData = /** @class */ (function () {
    function GanttTaskData() {
    }
    return GanttTaskData;
}());
var GanttData = /** @class */ (function () {
    function GanttData() {
        this.series = [];
    }
    return GanttData;
}());
var GanttSeries = /** @class */ (function () {
    function GanttSeries() {
    }
    return GanttSeries;
}());
//# sourceMappingURL=general-gantt.component.js.map